import React from 'react';

import Column from '@amzn/meridian/column';
import Link from '@amzn/meridian/link';
import Text from '@amzn/meridian/text';

import CraneBlack from 'src/images/crane_black.svg';

export const PageNotFound = () => (
    <Column alignmentHorizontal="center" alignmentVertical="center" width="100%">
        <Text type="h600">Sorry, that page couldn't be found</Text>
        <Text type="h400">
            Try going back to&nbsp;
            <Link href="/">home</Link>
        </Text>
        <img src={CraneBlack} alt="Logo" width={100} />
    </Column>
);
